import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'
import type WritingLegendsVocabularyBankRoute from 'teacher-ui-client/reporting/ui-scope/writing-legends/vocabulary/bank/route'

export default class WritingLegendsVocabularyBankController extends Controller<
  ModelFor<WritingLegendsVocabularyBankRoute>
> {
  queryParams = ['sort']

  @tracked sort = 'first_name'
}
